import {
  Box,
  Button,
  Flex,
  Text,
  useColorMode,
  Heading,
  Link,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { AiOutlineDownload } from "react-icons/ai";
import { Helmet } from "react-helmet";
import Ajay_Resume from "./Ajay_Resume.pdf";
import Sidebar from "./Sidebar";

const Navbar = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const [title, setTitle] = useState("Home");

  return (
    <>
      <Box width={"100vw"}>
        <Helmet>
          <title>{`Ajay | ${title}`}</title>
        </Helmet>
      </Box>
      <Box
        id="nav-menu"
        pos={"sticky"}
        zIndex="7"
        top="0"
        width={"100vw"}
        textTransform={"capitalize"}
      >
        <Flex
          justify={"space-between"}
          height="4rem"
          align={"center"}
          transition={"all 1s"}
        >
          <Box height="3.5rem" >
            <Link
              href="#home"
              _hover={{
                textDecoration: "none",
              }}
            >
              <Heading as="h1">&nbsp;&nbsp; AJAY</Heading>
            </Link>
          </Box>

          <Flex
            display={{ base: "none", lg: "flex" }}
            width={"50%"}
            justify="space-around"
            align={"center"}
            marginRight="1%"
            fontWeight={"bold"}
          >
            <Link
              onClick={() => setTitle("Home")}
              href="#home"
              className="nav-link home"
            >
              home
            </Link>
            <Link
              onClick={() => setTitle("About")}
              href="#about"
              className="nav-link about"
            >
              about
            </Link>
            <Link
              onClick={() => setTitle("Skills")}
              href="#skills"
              className="nav-link skills"
            >
              skills
            </Link>
            <Link
              onClick={() => setTitle("Projects")}
              href="#projects"
              className="nav-link projects"
            >
              projects
            </Link>
            <Link
              onClick={() => setTitle("Github")}
              href="#github"
              className="nav-link github"
            >
              github
            </Link>
            <Link
              onClick={() => setTitle("Contact")}
              href="#contact"
              className="nav-link contact"
            >
              contact
            </Link>
            <Button
              width="max-content"
              colorScheme={"teal"}
              id="resume-button-1"
              className="nav-link resume"
              onClick={() => {
                window.open(
                  "https://drive.google.com/file/d/1FaGp-WVtNALfsCMVjZESGzTDR6q3SpRf/view?usp=drive_link",
                  "_blank"
                );
              }}
            >
              <a
                id="resume-link-1"
                href={Ajay_Resume}
                target="_blank"
                rel="noreferrer"
                download="Ajay_Resume.pdf"
              >
                Resume
              </a>
              <Text as="span" ml={"2"}>
                <AiOutlineDownload fontSize={"1.2rem"} />
              </Text>
            </Button>
            <Button onClick={toggleColorMode}>
              {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            </Button>
          </Flex>
          <Box display={{ lg: "none" }} marginRight="10px">
            <Sidebar />
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default Navbar;
